// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function KitchenSinkPreset(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'KitchenSinkPreset',
      'aria-hidden': true,
      focusable: false,
      width: 32 * scale,
      height: 32 * scale,
      viewBox: '0 0 32 32',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement(
      'g',
      {fill: 'currentColor'},
      createElement('path', {
        d: 'M25.483 9.955A7.844 7.844 0 0024.03 13a2 2 0 004 0 7.844 7.844 0 00-1.452-3.045.69.69 0 00-1.096 0z',
      }),
      createElement('path', {
        d: 'M31.385 23.348a1.333 1.333 0 00-1.148-2.015h-7.873a.667.667 0 01-.667-.666v-.334A1.333 1.333 0 0123.031 19h4.333a1.333 1.333 0 000-2.667h-4.333a4 4 0 00-4 4v.334a.667.667 0 01-.667.666h-.333a.667.667 0 01-.667-.666V6.333a3.667 3.667 0 017.333 0v1a1.333 1.333 0 002.667 0v-1a6.333 6.333 0 00-12.667 0v14.334a.667.667 0 01-.666.666h-.334a.667.667 0 01-.666-.666v-.334a4 4 0 00-4-4H4.697a1.333 1.333 0 100 2.667h4.334a1.333 1.333 0 011.333 1.333v.334a.667.667 0 01-.667.666H1.676a1.25 1.25 0 00-1.079 1.879 17.948 17.948 0 0030.788.133z',
      })
    )
  );
}
